import { isNil } from 'lodash';
import dayjs from 'dayjs';
import 'dayjs/locale/ko';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import weekday from 'dayjs/plugin/weekday';
import localeData from 'dayjs/plugin/localeData';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import duration from 'dayjs/plugin/duration';
import isBetween from 'dayjs/plugin/isBetween';
import dayjsBusinessDays from 'dayjs-business-days2';

dayjs.extend(localizedFormat);
dayjs.extend(weekday);
dayjs.extend(localeData);
dayjs.extend(customParseFormat);
dayjs.extend(duration);
dayjs.extend(isBetween);
dayjs.extend(dayjsBusinessDays);

dayjs.locale('ko');

export const validDate = (date: string | Date | dayjs.Dayjs | null | undefined): boolean => {
  return dayjs(date).isValid();
};

export const setDateFormat = (date: string | Date | dayjs.Dayjs | null | undefined, format = 'LL'): string => {
  if (!date || !validDate(date)) return '-';
  return dayjs(date).format(format);
};

export const addBusinessDays = (
  date: string | Date | dayjs.Dayjs | null | undefined,
  addDay: number | null | undefined,
): dayjs.Dayjs | undefined => {
  if (!isNil(date) && !isNil(addDay)) {
    return dayjs(date).businessDaysAdd(addDay);
  }
};

export const formatDatePeriod = (
  startDate: string | Date | dayjs.Dayjs | null | undefined,
  endDate: string | Date | dayjs.Dayjs | null | undefined,
  format = 'LLL',
): string => {
  if (!startDate || !endDate) {
    return '-';
  }
  const start = dayjs(startDate).format(format);
  const end = dayjs(endDate).format(format);
  return `${start} - ${end}`;
};

export const momentBusinessDay = dayjs;

export default dayjs;
